export default "__VITE_ASSET__Dt2WhCTo__"